module.exports = __webpack_public_path__ + "static/media/YF25_4.87643cf5.jpg";